<div class="signature-pad-container">
    <canvas #signaturePad></canvas>

    <p style="font-size: medium; line-height: 1.5; color: black; margin-top: 16px; font-size: medium;">{{OTPMessage}}</p>
    <form [formGroup]="otpForm">
      <div style="width: 100%; display: flex; align-items: center; justify-content: center; margin-bottom: 30px; margin-top: 30px;" *ngIf="!isLoading">
        <ng-otp-input #ngOtpInput
          (onInputChange)="onOtpChange($event)"
          [config]="{length:6, allowNumbersOnly: true}"></ng-otp-input>
      </div>
    </form>

    <div class="timer-holder">
      <div *ngIf="countdown > 0" class="timer-box">
        <span style="font-weight: 900;">{{countdown}}</span>&nbsp;{{timerText}}
      </div>
      <div *ngIf="countdown <= 0" class="timer-box" style="background-color: #f3dcdc;">
        <span style="font-weight: 900;">{{'OTP expired'}}</span>
      </div>
      <div class="resend" (click)="sendOTP()" [ngClass]="{'ready-send': countdown <= 10}">
        <mat-icon style="margin-right: 5px;" fontIcon="{{resendIcon}}"></mat-icon>
        <u>{{requestingOTP ? ' Requesting new OTP ...' : resendOTPText}}</u>
      </div>
    </div>
    
    <div class="line-x"></div>

    <div class="flex button-container">
      <button (click)="clear()" *ngIf="!isCanvasBlank()" [disabled]="isLoading">Clear Signature</button>
      <button (click)="verifyOtp()" *ngIf="OTPValid" class="flex center verify" [disabled]="isLoading">
        {{isLoading ? 'Verifying' : submitText}}
          
        <span class="spinning" *ngIf="isLoading">
          <mat-progress-spinner
          mode="indeterminate" diameter="25" strokeWidth="4"></mat-progress-spinner>
        </span>
      </button>
    </div>
</div>
